import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import Box from "@material-ui/core/Box";
import shortid from "shortid";
import Avatar from "@material-ui/core/Avatar";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const WebsiteCardSteps = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = true;

	const columns = "3"; // 1, 2 , 3 , 4
	const header = `Our Accredited Programs`;
	const subHeader = `Kids ‘R’ Kids Learning Academy is fully accredited and offers the ultimate foundation for your child.`;
	const tagline = "Now Enrolling";
	const textAlign = "left"; // left / center / right
	const lineBreak = true;
	const content = "";

	const button = "";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "";
	const buttonSecondaryLink = "/wesbite/about-us";

	const type = "numbered"; // numbered / checkbox / none

	const cards = [
		{
			header: "Infant Program",

			description:
				"Ensure your infant gets the tender care and attention they need while you're away at work by enrolling them in our infant care program. Call us for details.",
			buttonText: "Learn more",
			buttonLink: "/",
		},
		{
			header: "Toddler Program",

			description:
				"Give your toddler an early head start with our toddler care programs. Our teachers make sure that your child learns while having fun in a safe environment.",
			buttonText: "Learn more",
			buttonLink: "/",
		},
		{
			header: "Preschool Program",

			description:
				" Children will start to learn to write, recognize their name, and learn their ABC’s.",
			buttonText: "Learn more",
			buttonLink: "/",
		},
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={10}
							justifyContent="center"
							alignItems={
								textAlign === "left"
									? "flex-start"
									: textAlign === "right"
									? "flex-end"
									: "center"
							}
						>
							{(tagline ||
								header ||
								subHeader ||
								lineBreak ||
								content ||
								button ||
								buttonSecondary) && (
								<Grid item xs={12}>
									<Box
										display={"flex"}
										flexDirection={"column"}
										justifyContent={"center"}
										alignItems={
											textAlign === "left"
												? "flex-start"
												: textAlign === "right"
												? "flex-end"
												: "center"
										}
										height={"100%"}
									>
										{tagline && (
											<Box className="tagline" textAlign={textAlign}>
												{tagline}
											</Box>
										)}

										{header && (
											<Box component={"h2"} textAlign={textAlign}>
												{header}
											</Box>
										)}

										{subHeader && (
											<Box component={"h3"} textAlign={textAlign}>
												{subHeader}
											</Box>
										)}

										{lineBreak && (
											<Box my={1} textAlign={textAlign}>
												<LineBreak className={classes.lineBreak} />
											</Box>
										)}

										{content && (
											<>
												<Box component={"p"} textAlign={textAlign}>
													{content}
												</Box>
											</>
										)}

										{(button || buttonSecondary) && (
											<>
												<div className={classes.columnButtonsBox}>
													{button && (
														<Button
															size="large"
															color="primary"
															variant="contained"
															disableElevation
															href={buttonLink}
															className="columnButton"
														>
															{button}
														</Button>
													)}

													{buttonSecondary && (
														<Button
															size="large"
															color="secondary"
															variant="outlined"
															disableElevation
															href={buttonSecondaryLink}
															className="columnButton"
														>
															{buttonSecondary}
														</Button>
													)}
												</div>
											</>
										)}
									</Box>
								</Grid>
							)}

							<Grid item xs={12}>
								<Grid container spacing={8}>
									{cards.map((card, index) => (
										<Grid
											item
											xs={12}
											sm={12}
											md={
												columns === "1"
													? 12
													: columns === "2"
													? 6
													: columns === "3"
													? 4
													: 3
											}
											key={shortid.generate()}
										>
											<div className={classes.columnShadowBox}>
												{type === "numbered" ? (
													<div className={classes.iconColumnNumber}>
														{index + 1}
													</div>
												) : (
													type === "checkbox" && (
														<CheckCircleIcon
															className={classes.iconColumnCheckbox}
														/>
													)
												)}
												<div>
													<div className={classes.cardHeader}>
														{card.header}
													</div>
													<div className={classes.cardDescription}>
														{card.description}
													</div>
												</div>
												<Box mt={"auto"}>
													<Button
														size="large"
														color="primary"
														endIcon={<ArrowForwardIcon />}
													>
														{card.buttonText}
													</Button>
												</Box>
											</div>
										</Grid>
									))}
								</Grid>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteCardSteps;
